import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiPeople from '../../Api/ApiPeople';
import ToastMsg from '../../Components/ToastMsg';
import { creators as PeopleActions } from '../../Reducers/Reporting/People';

export function* getPeopleSummary({ payload }) {
  try {
    const response = yield call(ApiPeople.getSummary, payload.DimDate);

    if (response.status === 200) {
      yield put(PeopleActions.peopleSuccess({ summaryData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'People Summary',
            text: response.message,
          },
        },
      );
      yield put(PeopleActions.peopleFailure(response.message));
    }
  } catch (e) {
    yield put(PeopleActions.peopleFailure(e));
  }
}

export function* getPeopleDetail({ payload }) {
  try {
    const response = yield call(ApiPeople.getDetail, payload.DimDate);

    if (response.status === 200) {
      yield put(PeopleActions.peopleSuccess({ detailData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'People Detail',
            text: response.message,
          },
        },
      );
      yield put(PeopleActions.peopleFailure(response.message));
    }
  } catch (e) {
    yield put(PeopleActions.peopleFailure(e));
  }
}
